import TaskUpdateContent from './TaskUpdateContent';

export default TaskUpdateContent;
